module.exports = __webpack_public_path__ + "img/numeralia_home1.1d61ecd0.svg";